export type PermissionData = {
  name: string;
  value: string;
};

export interface PermissionProfileRequest {
  name: string;
  inherit_profile_id?: number;
  permission_data?: PermissionData[];
}

export interface PermissionProfilesPriorityRequest {
  id: number;
  priority: number;
}

export interface CopyPermissionProfileRequest {
  name: string;
  copy_team_permissions: boolean;
  copy_user_permissions: boolean;
}

export interface SimplePermissionProfileResponse {
  id: number;
  name: string;
  priority: number;
  creditors_count: number;
  teams_count: number;
  readonly?: boolean;
}

export interface PermissionProfileResponse {
  id: number;
  name: string;
  priority: number;
  inherit_profile_id?: number;
  inherit_permission_data?: PermissionData[];
  permission_data: PermissionData[];
}

export interface PermissionsRequest {
  team_ids: number[];
  creditor_ids: number[];
}

export type PermissionsResponse = PermissionsRequest;

export enum PlanGroupPermission {
  VIEW = 'view',
  EDIT = 'edit',
  DELETE = 'delete',
}

export type PlanGroupProfilesPermission = {
  permission_profile_id: number;
  sources: PlanGroupPermission[];
  calc: PlanGroupPermission[];
  can_unlock_periods: boolean;
};

export type PlanGroupPermissionRequest = PlanGroupProfilesPermission[];
